class ModalStockNotify extends ModalDialog {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.successWrapper = this.querySelector("[data-success-message]");
    this.errorWrapper = this.querySelector("[data-error-message]");
    this.form.addEventListener("submit", this.onSubmit.bind(this));
  }

  onSubmit(e) {
    e.preventDefault();
    fetch(e.target.action, {
      method: e.target.method,
      headers: {
        "accept": 'application/json',
        "revision": '2024-06-15',
        "content-type": 'application/json'
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: this.form.querySelector('input[type="email"]').value
                }
              }
            }
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${this.form.querySelector('[name="variant"]').value}`
              }
            }
          }
        }
      })
    })
      .then((response) => {
        if(response.status === 202) {
          this.onSuccess(this.form.querySelector('input[type="email"]').value);
        } else {
          this.onError("Sorry, there was a problem creating a notification.");
        }
      })
      .catch((error) =>
        this.onError(error.message || error.description || error)
      );
  }

  onSuccess(email) {
    this.successWrapper.textContent = email
      ? this.successWrapper.dataset.successMessage.replace("[email]", email)
      : "";
    this.successWrapper.classList.toggle("hidden", !email);
    this.onError(false);
  }

  onError(error) {
    this.errorWrapper.textContent = error || "";
    this.errorWrapper.classList.toggle("hidden", !error);
  }

  reset() {
    this.querySelector('input[name="email"]').value = '';
    this.onError(false);
    this.onSuccess(false);
  }

  hide() {
    super.hide();
    this.reset();
  }
}

customElements.define("modal-stock-notify", ModalStockNotify);
